import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ModalContext, useGlobalStore } from '../../../components/contexts';
import ExpertAnalyzeDetailController from '../../../controllers/expert/analyze/ExpertAnalyzeDetailController';
import ValidateService from '../../../services/ValidateService';
import AnalyzeDetailContent from './AnalyzeDetailContent';
import { LoadingContext } from '../../../components/contexts';

const ExpertAnalyzeDetail = () => {
  const location = useLocation();
  const [svcObj, setSvcObj] = useState(location.state?.rowData);
  const [render, setRender] = useState(0);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const [detailList, setDetailList] = useState([]);
  const detailListRef = useRef([]);
  const printRef = useRef(null);
  const navigate = useNavigate();
  const { setLoading } = useContext(LoadingContext);

  const onChangeDetailRef = (index, model, value) => {
    detailListRef.current[index][model] = value;

    // 모든 추가자료 제출 완료 체크
    if (model === 'addCmptnYn') {
      let allCmptn = true;
      for (const detailRef of detailListRef.current) {
        if (detailRef[model] !== 'Y') {
          allCmptn = false;
          break;
        }
      }

      setSvcObj({ ...svcObj, status: allCmptn ? 'EXPRT06' : 'EXPRT04' });
    }
    setRender(render + 1);
  };

  const controller = useMemo(() => {
    return new ExpertAnalyzeDetailController(
      store,
      modalService,
      validateService,
      { svcObj, setSvcObj },
      { detailList, setDetailList },
      { render, setRender },
      detailListRef,
      printRef,
      navigate,
      setLoading
    );
  }, [svcObj, detailList, detailListRef]);

  useEffect(() => {
    document.title = '전문가 분석 상세';
    controller.fnGetExpertAnalyzeDetail();
  }, []);

  const evlArtclNmList = [
    'neck',
    'trunk',
    'leg',
    'upperArm',
    'lowerArm',
    'wrist',
    'add',
  ];

  useEffect(() => {
    const newWorkMenuArr = [];
    const newPdfMenuArr = [];

    let isFirst = false;
    if (detailListRef.current.length === 0) {
      detailListRef.current = [];
      isFirst = true;
    }

    for (let i = 0; i < detailList.length; i++) {
      if (isFirst) {
        detailListRef.current.push({
          index: i,
          ...detailList[i],
        });

        if (detailListRef.current[i].resultList.length === 0) {
          const initResultList = [];
          for (let i = 0; i < evlArtclNmList.length; i++) {
            initResultList.push({
              seq: i,
              evlArtclNm: evlArtclNmList[i],
              poseInfo: null,
              addInfo1: null,
              addInfo2: null,
              exprtScr: null,
              owasScr: null,
              rulaScr: null,
              rebaScr: null,
            });
          }
          detailListRef.current[i].resultList = initResultList;
        }
      }

      newWorkMenuArr.push({
        name: detailListRef.current[i].workNm,
        content: (
          <AnalyzeDetailContent
            key={detailListRef.current[i].exprtAnlsDtlId}
            svcObj={svcObj}
            detailRef={detailListRef.current[i]}
            onChangeDetailRef={onChangeDetailRef}
            modalService={modalService}
          />
        ),
      });

      // newPdfMenuArr.push({
      //   name: detailListRef.current[i].workNm,
      //   content: (
      //     <AnalyzeReportWrite
      //       key={render + detailListRef.current[i].exprtAnlsDtlId}
      //       id={render + detailListRef.current[i].exprtAnlsDtlId}
      //       detailRef={detailListRef.current[i]}
      //       onChangeDetailRef={onChangeDetailRef}
      //       isReadOnly={false}
      //     />
      //   ),
      // });
    }
    setWorkMenuArr(newWorkMenuArr);
    // setPdfMenuArr(newPdfMenuArr);

    // setTimeout(() => {
    //   if (printRef.current) {
    //     printRef.current.style.display = 'none';
    //   }
    // }, 1000);
  }, [svcObj, detailList, render]);

  // 작업 menu 기능 구현
  const [currentWorkMenu, setCurrentWorkMenu] = useState(0);
  const [workMenuArr, setWorkMenuArr] = useState([]);
  // pdf 보고서 항목
  const [pdfMenuArr, setPdfMenuArr] = useState([]);

  const selectWorkMenuHandler = index => {
    setCurrentWorkMenu(index);
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">전문가 분석 상세</h2>
      </div>
      <div className="tbl-wrap">
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">공정</th>
              <td>
                <div className="input-group">
                  <input
                    aria-label="공정명"
                    type="text"
                    className="form-control md"
                    value={svcObj.taskNm}
                    readOnly
                  />
                  {svcObj.status === 'EXPRT02' && store.authrtId === 'EX' ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => controller.fnExpertMatch()}
                    >
                      전문가 매칭
                    </button>
                  ) : null}
                  <button
                    type="button"
                    className="btn sm"
                    onClick={() => {
                      modalService.openModal('AnalyzeBasicSurvey', svcObj);
                    }}
                  >
                    기본 조사표
                  </button>
                  <button
                    type="button"
                    className="btn sm"
                    onClick={() => {
                      modalService.openModal('AnalyzeSurveySymptom', svcObj);
                    }}
                  >
                    증상 조사표
                  </button>
                  <button
                    type="button"
                    className="btn sm"
                    onClick={() => {
                      modalService.openModal('AnalyzeAiScore', svcObj);
                    }}
                  >
                    분석 도구별 기준표
                  </button>
                  {/*{svcObj.status === 'EXPRT05' ? (
                    <button
                      type="button"
                      className="btn sm"
                      onClick={() => {
                        controller.fnDownloadExpertPDF();
                      }}
                    >
                      보고서 다운로드
                    </button>
                  ) : null}*/}
                  {(svcObj.status === 'EXPRT03' ||
                    svcObj.status === 'EXPRT04' ||
                    svcObj.status === 'EXPRT06') &&
                  store.authrtId === 'EX' ? (
                    <>
                      <button
                        type="button"
                        className="btn sm"
                        onClick={() => controller.fnSave('Y')}
                      >
                        임시저장
                      </button>
                      <button
                        type="button"
                        className="btn sm"
                        onClick={() => controller.fnSave('N')}
                      >
                        분석 완료
                      </button>
                    </>
                  ) : null}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="tbl-wrap">
        {svcObj.status === 'EXPRT04' && store.authrtId === 'ME' ? (
          <p className="tbl-msg">
            <em className="exc-mark"></em>
            추가 자료 제출이 완료되지 않은 작업입니다. 모든 작업의 추가 자료가
            제출이 완료되어야 합니다.
          </p>
        ) : null}
        <div className="work-tabs-wrap">
          <ul id="workMenu" className="nav-tabs">
            {detailListRef.current.map((el, index) => (
              <li
                key={index}
                className={index === currentWorkMenu ? 'tabs on' : 'tabs'}
                onClick={() => selectWorkMenuHandler(index)}
              >
                <a>
                  {el.addCmptnYn === 'N' &&
                  svcObj.status === 'EXPRT04' &&
                  store.authrtId === 'ME' ? (
                    <em className="exc-mark"></em>
                  ) : null}
                  {el.workNm}
                </a>
              </li>
            ))}
          </ul>
        </div>
        {workMenuArr[currentWorkMenu]?.content}
      </div>
      <section
        className="pdf-form-container"
        id="pdf-form"
        ref={printRef}
        style={{
          display: 'none',
        }}
      >
        <div
          className="pdf-content"
          style={{
            width: '100%',
            height: '100%',
            margin: '0',
            padding: '0',
          }}
        >
          {pdfMenuArr.map((pdfMenu, index) => {
            return (
              <div
                key={index}
                style={{
                  width: '100%',
                  minHeight: '296mm',
                  padding: 'var(--krds-spacer-8)',
                  pageBreakAfter: 'always',
                }}
              >
                <div className="wrapper-container">{pdfMenu.content}</div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default ExpertAnalyzeDetail;
